import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "print-template" }
const _hoisted_2 = { id: "part1" }
const _hoisted_3 = { style: {"text-align":"center","font-size":"20px","font-weight":"bold"} }
const _hoisted_4 = { style: {"display":"flex","width":"100%"} }
const _hoisted_5 = { class: "table-descri" }
const _hoisted_6 = { class: "table-descri-li" }
const _hoisted_7 = { class: "table-descri-content" }
const _hoisted_8 = { class: "table-descri-li" }
const _hoisted_9 = { class: "table-descri-content" }
const _hoisted_10 = { class: "table-descri-li" }
const _hoisted_11 = { class: "table-descri-content" }
const _hoisted_12 = { id: "part2" }
const _hoisted_13 = { style: {"display":"flex","width":"100%","margin-top":"100px"} }
const _hoisted_14 = { style: {"position":"relative"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_ZPreview = _resolveComponent("ZPreview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.printDetail.titleDetail.name), 1),
      _cache[3] || (_cache[3] = _createElementVNode("h3", { style: {"text-align":"center","font-size":"20px","font-weight":"bold"} }, "维修报价单", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_descriptions, {
          column: 1,
          style: {"width":"49.5%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "TO 收件人：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.customerCompanyContactDetail.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "E-mail 电邮：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.receivingEmail), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "Company 公司：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.customerCompanyDetail.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "Tel 电话：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.customerCompanyContactDetail.phone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "Project 报价项目：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.details[0].businessName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "Model 型号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.details[0].businessModel), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions, { column: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "Quote From 报价人：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.salesManDetail.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "Tel 电话：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.salesManDetail.phone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "Line 座机：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.titleDetail.phone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "E-Mail 电邮：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.salesManDetail.email), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "Date 日期：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(new Date().toLocaleDateString().replace(/\//g, '-')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "Quote No.业务编号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.details[0].businessNo), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "form-title" }, "工作描述：", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "table-descri-lable" }, "设备故障现象", -1)),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.printDetail.fault), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "table-descri-lable" }, "初步检测情况", -1)),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.printDetail.checkDes), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "table-descri-lable" }, "损坏元件", -1)),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.printDetail.changeParts), 1)
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "form-title" }, "报价明细：", -1))
    ]),
    _createVNode(_component_vxe_table, {
      border: "",
      "show-footer": "",
      ref: "xTable",
      align: "center",
      class: "mt-20",
      "print-config": _ctx.tablePrint,
      "keep-source": "",
      "auto-resize": "",
      "column-config": { resizable: true },
      "footer-method": _ctx.footerMethod,
      "seq-config": { seqMethod: _ctx.seqMethod },
      "merge-footer-items": _ctx.mergeFooterItems,
      data: _ctx.printDetail.details
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "index",
          width: "50",
          title: "序号"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(" No." + _toDisplayString(row.index), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "businessName",
          title: "名称",
          "min-width": "120"
        }),
        _createVNode(_component_vxe_column, {
          field: "amount",
          title: "数量",
          width: "60"
        }),
        _createVNode(_component_vxe_column, {
          field: "price",
          title: "含税单价",
          "min-width": "100",
          "header-align": "center"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.$currency(row.price)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "totalPrice",
          title: "含税总价",
          "min-width": "100",
          "header-align": "center"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.$currency(row.price * row.amount)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "mark",
          title: "备注",
          "min-width": "100"
        })
      ]),
      _: 1
    }, 8, ["print-config", "footer-method", "seq-config", "merge-footer-items", "data"]),
    _createElementVNode("div", _hoisted_12, [
      _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "form-title" }, "备注：", -1)),
      _createElementVNode("pre", null, _toDisplayString(_ctx.printDetail.quotationMarkTemplateDetail.mark) + " ", 1),
      _createElementVNode("div", _hoisted_13, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"width":"49%"} }, [
          _createTextVNode(" 客户代表方签字："),
          _createElementVNode("span", { class: "sign-container-border" })
        ], -1)),
        _createElementVNode("div", _hoisted_14, [
          _cache[6] || (_cache[6] = _createTextVNode(" 业务签字：", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "sign-container-border" }, null, -1)),
          _createVNode(_component_ZPreview, {
            authSrc: _ctx.printDetail.titleDetail.sealImg,
            width: "100px",
            height: "100px",
            class: "upload-file_preview"
          }, null, 8, ["authSrc"])
        ])
      ])
    ])
  ]))
}